import PropTypes from 'prop-types';

import useFormData from '@gef-ui/form-core/hooks/state/useFormData';
import { validationDisplayTypes } from '@gef-ui/form-material/constants';
import EmailSuggest from '@gef-ui/form-material/EmailSuggest';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { codelistProvider } from 'components';
import { codelists } from 'constants/codelists';
import { FIELDS } from 'features/other/copyEmail/form';

export const EmailSuggestAutoComplete = ({ emailDomains = [] }) => {
	const formData = useFormData();

	return (
		<EmailSuggest
			label={getLabelMessage('common:email')}
			fieldName={FIELDS.email}
			labelPropName="shortDescription"
			valuePropName="shortDescription"
			options={emailDomains}
			validationDisplay={!formData?.email ? validationDisplayTypes.HIDDEN : undefined}
			TextFieldProps={{
				required: true,
			}}
		/>
	);
};

EmailSuggestAutoComplete.propTypes = {
	emailDomains: PropTypes.array,
};

export default codelistProvider(codelists.emailDomains, 'emailDomains')(EmailSuggestAutoComplete);
